import { useEffect, useState } from 'react'

export function ScanLines() {
  const [lines, setLines] = useState<number[]>([])

  useEffect(() => {
    // Create scan lines
    const newLines = Array.from({ length: 3 }, (_, i) => i)
    setLines(newLines)
  }, [])

  return (
    <div className="fixed inset-0 z-10 pointer-events-none overflow-hidden">
      {lines.map((_, index) => (
        <div
          key={index}
          className="absolute left-0 right-0 h-[2px] opacity-30"
          style={{
            background: 'linear-gradient(90deg, transparent, #00ffff, transparent)',
            animation: `scan ${3 + index * 0.5}s linear infinite`,
            animationDelay: `${index * 1}s`,
            top: 0,
          }}
        />
      ))}
      {/* Horizontal grid lines */}
      <div className="absolute inset-0 grid-pattern opacity-30" />
    </div>
  )
}
